<template>
    <v-card>
        <v-toolbar flat dark color="info" dense>
            <v-toolbar-title>Risorse</v-toolbar-title>
        </v-toolbar>
        <v-data-table item-key="id" :headers="headers" :items="value" :disable-pagination="true" hide-default-footer>
            <template v-slot:item.resource.name="{ item }">
                <resource-selector v-if="!disabled" v-model="item.resource" :return-object="true" required dense
                    :rules="rules.resource" @input="v => item.resource_id = v && v.id" v-bind="{ loading, disabled }" />
                <a v-else-if="item.resource.email" :href="'mailto:' + item.resource.email">
                    {{ item.resource?.name || '-' }}</a>
                <span v-else>{{ item.resource?.name || '-' }}</span>
            </template>
            <template v-slot:item.hours="{ item }">
                <!--
                <float-input v-model="item.hours" :rules="rules.hours" v-bind="{ loading, disabled }" suffix="h"
                    :decimals="2"></float-input>-->
                <nice-time-editor v-if="permissions.includes('view_sub_tasks_resources_hours')" v-model="item.hours" v-bind="{ loading, disabled:!permissions.includes('edit_sub_tasks_resources_hours') }"></nice-time-editor>
                <span v-else>-</span>
            </template>
            <template v-slot:item.hours_real="{ item }">
                <!--
                <float-input v-model="item.hours_real" v-bind="{ loading, disabled }" suffix="h" :rules="rules.hours_real"
                    :decimals="2"></float-input>
                -->
                <nice-time-editor v-if="(item.resource?.id && item.resource.id == user.resource_id) || permissions.includes('view_sub_tasks_resources_hours_real')" v-model="item.hours_real" v-bind="{ loading, disabled:!permissions.includes('edit_sub_tasks_resources_hours_real') }"></nice-time-editor>
                <span v-else>-</span>
            </template>
            <template v-slot:item.price="{ item, index }">
                <template v-if="item.resource">
                    <float-input v-if="item.resource.type === 'supplier' && permissions.includes('view_sub_tasks_resources_price')" v-model="item.price"
                        v-bind="{ loading, disabled:!permissions.includes('edit_sub_tasks_resources_price') }" prepend-icon="euro" :decimals="2"></float-input>
                    <template v-else>
                        
                        <price-info v-if="permissions.includes('view_sub_tasks_resources_price')" :value="resourceInfo[index]"></price-info>
                        <span v-else></span>
                    </template>
                </template>
            </template>
            <template v-slot:item.actions="{ item, index }">
                <v-btn v-if="!disabled" icon small color="error"
                    @click="removeRow(item, index)"><v-icon>delete</v-icon></v-btn>
            </template>
        </v-data-table>
        <v-card-actions v-if="!disabled">
            <v-btn small color="success" @click="addResource"><v-icon left>add</v-icon>Aggiungi risorsa</v-btn>
        </v-card-actions>
    </v-card>
</template>
<script>
import { Vuelidator, Rule } from '../../Vuelidator/index.js';
import { NormalizeSubTaskResource, calculateSubtaskResourceInfo } from './ProjectUtils.js';
import NiceTimeEditor from '../NiceTimeEditor.vue';

export default {
    props: {
        value: { type: Array, required: false },//sub_tasks.resources
        loading: { default: false, },
        disabled: { default: false, },
        showPrices: { type: Boolean, default: true },
        permissions: {type: Array, default:[]},
        user:{type:Object, required: true},
    },
    data() {
        const validator = new Vuelidator({
            resource: [Rule.required()],
            resource_id: [Rule.required(), Rule.min(0)],
            hours: [Rule.nullable(), Rule.numeric(), Rule.min(0)],
            hours_real: [Rule.required(), Rule.numeric(), Rule.min(0)],
            price: [Rule.required(), Rule.min(0)],
        });
        const rules = validator.getRules();

        let headers = [
            { text: 'Risorsa', value: 'resource.name', },
            { text: 'Ore Stimate', value: 'hours', width: '120px', },
            { text: 'Ore reali', value: 'hours_real', width: '120px', },
            { text: 'Prezzo', value: 'price', width: '200px', sortable: false, },
            { text: '', value: 'actions', width: '50px', sortable: false, },
        ];
        ///remove price column if showPrices = false
        if (!this.showPrices)
            headers.splice(3, 1);

        return {
            headers,
            rules,
        };
    },
    mounted(){
        console.log(this.value);
    },
    computed: {
        resourceInfo() {
            return this.value.map(e => calculateSubtaskResourceInfo(e));
        }
    },
    methods: {
        addResource() {
            const row = NormalizeSubTaskResource({});
            this.value.push(row);
        },
        removeRow(item, index) {
            if (confirm('Sei sicuro di voler eliminare la riga selezionata?')) {
                this.value.splice(index, 1);
            }
        }
    },
    filters: {
        calcRowPrice(item) {
            return '-';
        }
    },
    components: {
        NiceTimeEditor,
    }
}
</script>